export default "__VITE_ASSET__CZfSa4hX__"